import React from 'react';
import agent from '../agent';
const Promise = global.Promise;

class Upload extends React.Component {
  constructor() {
    super();

    this.state = {
      files: [
        {
          fileBody: null, 
          url: ''
        }
      ],
    }

    this.onChangeHandler = event => {
      let files = this.state.files.map((file, i) => {
        if(i == event.target.dataset.count) {
          return {fileBody: event.target.files[0], url: event.target.files[0] ? URL.createObjectURL(event.target.files[0]) : ''}
        }else {
          return file;
        }
      })
      const newState = Object.assign({}, this.state, {files: files});
      this.setState(newState);
    }

    this.uploadFiles = () => {
      const data = new FormData();
      for (var i = 0; i < this.state.files.length; i++){
        if(this.state.files[i].fileBody) {
          data.append(i, this.state.files[i].fileBody);
        }
      }
      const req = new XMLHttpRequest();
      var that = this;
      req.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
          console.log(JSON.parse(req.responseText));
          that.updateState(JSON.parse(req.responseText));
        }else if(this.readyState == 4 && this.status !== 200) {
          alert('Error occurred. Please try again');
        }
      };
      req.open("POST", "https://dearinvite.com/sites/files");
      req.send(data);
      this.updateState([]);
    }

    this.addFile = () => {
      const files = [...this.state.files, {fileBody: null, url: ''}]
      const newState = Object.assign({}, this.state, {files: files});
      this.setState(newState);
    }
    
    this.removeFile = event => {
      let files = [];
      this.state.files.map((file, i) => {
        if(i != event.target.dataset.count) {
          files.push(file);
        }
      });
      const newState = Object.assign({}, this.state, {files: files});
      this.setState(newState);
    }

    this.updateState = (results) => {
      const files = [];
      let resultObj = {};
      if(results) {
        results.map(result => {
          resultObj[result.attr] = '/files/'+result.newName;
        })
      }
      this.state.files.map((file, i) => {
        let updatedFile = Object.assign({}, file, {message: resultObj[i.toString()] ? resultObj[i.toString()] : 'Uploading...'})
        files.push(updatedFile);
      });
      const newState = Object.assign({}, this.state, {files: files});
      this.setState(newState);
    };
  }

  render() {
    return (
      <div className="container">
        <h2>Upload files</h2>
        <br/>
        <button type="button" class="btn btn-primary" onClick={this.addFile}>Add File</button> 
        <br/>
        <br/>
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Action</th>
              <th>Choose File</th>
              <th>Preview</th>
              <th>Message</th>
            </tr>
          </thead>
          <tbody>
            {this.state.files.map((fileObj, i) => 
              <tr key={i} style={{marginBottom: '5px'}}>
                <td>
                  { i !== 0 && 
                    <button type="button" data-count={i} class="btn btn-danger" onClick={this.removeFile}>Remove File</button> 
                  }
                </td>
                <td>
                  <input type="file" name="file" data-count={i} onChange={this.onChangeHandler}/>
                </td>
                <td>
                  {fileObj.url && 
                    <img style={{borderRadius : '100%', maxWidth: '200px', maxHeight: '200px'}} src={fileObj.url}/>
                  }
                </td>
                <td>
                  {fileObj.message}
                </td>
              </tr>
            )}
          </tbody>
        </table>
        
        <div class="text-center">
          <button type="button" class="btn btn-success" onClick={this.uploadFiles}>Upload All</button> 
        </div>
      </div>
    );
  }
}

export default Upload;
